import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import {Button, Toast, Loading, Label, Radio, FormGroup, InputHint} from "spectre-react/dist/cjs";
import {getPDFModalInfo} from '../../api';


const CommentBlockOption = ({commentBlockOption, onChange, isCommentPresent}) => {
    return (
        <FormGroup className="mb-4">
            <Label>Блок с замечаниями:</Label>
            <Radio name="showCommentsBlock" value="HIDE" checked={commentBlockOption === "HIDE"} onChange={onChange}>
                не вносить вообще
            </Radio>
            <Radio name="showCommentsBlock" value="SHOW_BLANK" checked={commentBlockOption === "SHOW_BLANK"} onChange={onChange}>
                внести пустые строки
            </Radio>
            <Radio name="showCommentsBlock" value="SHOW_COMMENT" checked={commentBlockOption === "SHOW_COMMENT"} onChange={onChange}>
                внести занесенное в репорт
            </Radio>
            <InputHint renderAs="div" className={cx({"d-none": commentBlockOption !== "SHOW_COMMENT"})}>
                {!isCommentPresent && "поле с замечаниями пустое, будут внесены пустые строки"}
                {isCommentPresent && "поле с замечаниями не пустое"}
            </InputHint>
        </FormGroup>
    )
};

const DownloadButtonsBlock = ({contractNumbers, commentBlockOption, baseHref}) => {
    if (contractNumbers.length > 0) {
        return (
            <FormGroup>
                <Label>Скачать:</Label>
                <div>
                    {contractNumbers.map(contractNumber => (
                        <Button key={contractNumber}
                                primary block
                                href={`${baseHref}?commentBlockOption=${commentBlockOption}&contractNumber=${encodeURIComponent(contractNumber)}`}
                                className="btn-material-icon mt-4"
                        >
                            <span className="material-icons">picture_as_pdf</span> <span>контракт {contractNumber}</span>
                        </Button>
                    ))}
                    <Button block href={baseHref} className="btn-material-icon mt-4">
                        <span className="material-icons">picture_as_pdf</span> <span>без указания контракта</span>
                    </Button>
                </div>
            </FormGroup>
        );
    }

    return (
        <FormGroup>
            <Label>Скачать:</Label>
            <div>
                <Button primary block href={`${baseHref}?commentBlockOption=${commentBlockOption}`} className="btn-material-icon mt-4">
                    <span className="material-icons">picture_as_pdf</span> <span>без указания контракта</span>
                </Button>
            </div>
        </FormGroup>
    );
};


class ModalPDF extends React.PureComponent {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    getDefaultState() {
        return {
            isOpened: false,
            fetchState: 0, fetchError: undefined,
            reportId: undefined, contractNumbers: [], isCommentPresent: false,
            commentBlockOption: "HIDE",
        };
    }

    state = this.getDefaultState();

    open = async (reportId) => {
        this.setState({ isOpened: true, fetchState: 1, fetchError: undefined, reportId });

        try {
            const { contractNumbers, isCommentPresent } = await getPDFModalInfo(reportId);
            this.setState({
                fetchState: 2, fetchError: undefined,
                contractNumbers: contractNumbers ?? [],
                isCommentPresent: isCommentPresent ?? false
            });
        } catch (error) {
            this.setState({ fetchState: 0, fetchError: error.message });
        }
    };

    close = () => this.setState(this.getDefaultState());

    onShowCommentBlockChange = (ev) => this.setState({commentBlockOption: ev.target.value});

    render() {
        const {
            isOpened,
            fetchState, fetchError,
            reportId, contractNumbers, isCommentPresent,
            commentBlockOption,
        } = this.state;

        if (!isOpened)
            return null;

        let baseHref = `/api/reports/${reportId}/pdf`;

        if (process.env.NODE_ENV === "development")
            baseHref = `${window.location.origin}${baseHref}`.replace('3000', '5000');

        return (
            <div className="modal active modal-sm" id="report-pdf-modal">
                <span className="modal-overlay" onClick={this.close}/>
                <div className="modal-container modal-fullheight">
                    <div className="modal-header">
                        <button type="button" className="btn btn-clear float-right" onClick={this.close}/>
                        <div className="modal-title h5">PDF репорта</div>
                    </div>

                    <div className="modal-body">
                        {fetchState !== 2 && (
                            <div className="text-center">
                                <div>Загружаем номера контрактов...</div><br/>
                                <Loading large />
                            </div>
                        )}

                        {fetchError && <Toast error className="mb-2">{fetchError}</Toast>}

                        {fetchState === 2 &&
                            <CommentBlockOption commentBlockOption={commentBlockOption}
                                                isCommentPresent={isCommentPresent}
                                                onChange={this.onShowCommentBlockChange}
                            />
                        }

                        {fetchState === 2 &&
                            <DownloadButtonsBlock contractNumbers={contractNumbers}
                                                  commentBlockOption={commentBlockOption}
                                                  baseHref={baseHref}
                            />
                        }
                    </div>

                    <div className="modal-footer">
                        <Button link className="ml-2" onClick={this.close}>Закрыть</Button>
                    </div>
                </div>
            </div>
        )
    }
}


export default ModalPDF;